import { FormattedMessage } from 'react-intl';
import { Navigate, Outlet } from 'react-router-dom';

import { catchAll } from '@sorare/routing';

import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { NewPageHeader } from '@sorare/core/src/components/navigation/NewPageHeader';
import { PageHeader as OldPageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import {
  MLB_HOME,
  MLB_PLAY_LINEUPS,
  MLB_PLAY_LOBBY,
} from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { glossary, navLabels } from '@sorare/core/src/lib/glossary';
import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

import { ImportLineup } from '@sorare/gameplay/src/components/importLineup/ImportLineup';

const NewLayout = () => {
  const {
    flags: { useNewNav = false },
  } = useFeatureFlags();

  const { currentUser } = useCurrentUserContext();

  // Make sure existing users who are logged in are redirected to the home page
  if (!currentUser?.baseballUserProfile?.onboarded) {
    return <Navigate to={MLB_HOME} replace />;
  }

  const PageHeader = useNewNav ? NewPageHeader : OldPageHeader;

  return (
    <ContentWithStickyHeader
      header={
        <>
          <PageHeader text={glossary.play} disableBackBrowser />
          <TabBar variant="flat" fullWidth>
            <Tab matches={[catchAll(MLB_PLAY_LINEUPS)]} to={MLB_PLAY_LINEUPS}>
              <FormattedMessage {...glossary.lineups} />
            </Tab>
            <Tab matches={[catchAll(MLB_PLAY_LOBBY)]} to={MLB_PLAY_LOBBY}>
              <FormattedMessage {...navLabels.lobby} />
            </Tab>
          </TabBar>
        </>
      }
    >
      <Outlet />
    </ContentWithStickyHeader>
  );
};

const OldLayout = () => {
  return (
    <>
      <Outlet />
      <ImportLineup />
    </>
  );
};

const Layout = () => {
  const {
    flags: { useMlbOffseason = false },
  } = useFeatureFlags();

  return (
    <RequireAuth>
      {!useMlbOffseason ? <NewLayout /> : <OldLayout />}
    </RequireAuth>
  );
};

export default Layout;
